export function parseNumber(val?: string | number, fallback?: number): number {
  const d = fallback ? fallback : 0
  // replace any non-numeric characters
  let v = typeof val === 'string' ? parseFloat(val.replace(/[^0-9.-]/g, '')) : val
  if (isNaN(v)) {
    v = d
  }
  return v
}
